(function () {
  const submitBtn = document.querySelector(
    "form#ratingForm .rating-feedback-submit"
  );
  const ratingForm = document.querySelector("form#ratingForm");
  const pharmacyName = document.querySelector("#pharmacy-location");
  const textField = document.getElementById("message");
  const autocomplete = document.querySelector(".autocomplete-results-feedback");
  const pharmacyIDField = document.querySelector("#pharmacyid");
  const feedbackFormWrap = document.querySelector(".patient-feedback .card-box");
  const feedbackFormLocationLoader = document.querySelector(".load-feedback-autocomplete");

  let selectedPharmacyID = '';
  var formData = "";

  if (submitBtn) {
    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const isValid = validateForm();
      if (isValid) {
        feedbackFormWrap.innerHTML = '<div class="text-center modal-loader"><button type="button" class="btn btn-primary btn-loading"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="currentColor"></path></svg></button><h3 class="loading-wait">Submitting your feedback.</h3></div>';
        // ratingForm.submit();
        formData = new FormData(ratingForm);
        const formDataString = new URLSearchParams(formData).toString();
        submitPatientFeedback(formDataString.toString());
      }
    });
  }

  if (pharmacyName) {
    pharmacyName.addEventListener(
      "keyup",
      debounce(function (e) {
        enteredVal = this.value;
        autocomplete.innerHTML = "";
        getPharmacyNameSuburb(enteredVal);
      }, 800)
    );

    pharmacyName.addEventListener("keyup",(e)=>{
      value = this.value;
      if(value!=''){
        feedbackFormLocationLoader.style.display = "block";
      }
    })
  }

  function debounce(callback, delay) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(
        function () {
          callback.apply(this, args);
        }.bind(this),
        delay
      );
    };
  }

  function validateForm() {
    let isValid = true;

    //Clear Previous error message
    document.querySelectorAll(".error-message").forEach((errorDiv) => {
      errorDiv.textContent = "";
    });

    // Validate Name
    const nameField = document.getElementById("pharmacy-location");
    if (!nameField.value.trim()) {
      document.getElementById("nameError").textContent =
        "This field is required.";
      isValid = false;
    }

    const ratingField = document.querySelector('input[name="rating"]:checked');
    if (!ratingField) {
      document.getElementById("ratingError").textContent =
        "Rating is required.";
      isValid = false;
    }

    const ratingExpField = document.querySelector(
      'input[name="rating_experience"]:checked'
    );

    const messageField = document.getElementById("message");

    let charCount = messageField.value.length;
    const maxChars = 200;
    if (charCount > maxChars) {
      // Prevent additional input by trimming excess characters
      //   messageField.value = messageField.value.substring(0, maxChars);
      charCount = maxChars;
      document.getElementById("messageError").textContent =
        "Maximum of 200 characters allowed.";
      isValid = false;
    }
    return isValid;
  }

  if(textField){
      textField.addEventListener("input", () => {
        let charCount = textField.value.length;
        const maxChars = 200;
        if (charCount < maxChars) {
          document.getElementById("messageError").textContent = "";
        }
      });
  }

  if(pharmacyName){
      //Show autocomplete box on typing
      pharmacyName.addEventListener("input", () => {
        if (pharmacyName.value.trim() !== "") {
          autocomplete.style.display = "block";
        } else {
          autocomplete.style.display = "none";
        }
      });
  }

  // Close autocomplete box when clicking outside
  if( ratingForm ) {
    document.addEventListener("click", (event) => {
      if (!autocomplete.contains(event.target) && event.target !== pharmacyName) {
        autocomplete.style.display = "none";
      }
    });
  }

  function getPharmacyNameSuburb(enteredValue) {
    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", glide_custom_data.ajax_url, true);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );

    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        const responseData = JSON.parse(request.response);
        if (responseData.success == true) {
          feedbackFormLocationLoader.style.display = "none";
          autocomplete.innerHTML = responseData.selectoption;
          const pharmacyDropdown =
            document.querySelectorAll(".pharmacy-dropdown");
          pharmacyDropdown.forEach((dropdown) => {
            dropdown.addEventListener("click", () => {
              // pharmacyName.value = dropdown.textContent;
              pharmacyName.value = dropdown.getAttribute('data-attr-name');
              selectedPharmacyID = dropdown.getAttribute('data-attr-id');
              pharmacyIDField.value = selectedPharmacyID;
              setTimeout(() => {
                autocomplete.style.display = "none";
              }, 500);
            });
          });
        } else if (
          responseData.selectoption == "" &&
          autocomplete.value != ""
        ) {
          feedbackFormLocationLoader.style.display = "none";
          autocomplete.innerHTML = "No Pharmacies found";
        }
      } else if (request.readyState === 4) {
      }
    };
    const postData =
      `action=patient_feedback_submit&nonce=${encodeURIComponent(
        glide_custom_data.ajax_nonce
      )}&enteredValue=` + enteredValue + '&selectedID='+ selectedPharmacyID;
    request.send(postData);
  }

  function submitPatientFeedback(formDataString) {
    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", glide_custom_data.ajax_url, true);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );

    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        let response = request.response;
        let responseDataFeedback = JSON.parse(response);
        if(responseDataFeedback.feedbackSubmitted){
          feedbackFormWrap.innerHTML = "<div class='text-center d-flex flex-column align-items-center jusitfy-content-center thankyou-message'><h2>Thank you. Your feedback <br>is appreciated.</h2><br><span>- The Glide Team</span><a href=`#` class='btn btn-primary d-none'>Close</a></div>";
        }
      } else if (request.readyState === 4 && request.status === 400) {
        feedbackFormWrap.innerHTML = "<div class='text-center d-flex flex-column align-items-center jusitfy-content-center thankyou-message'><h2>Error while submitting your feedback</h2><br><span>- The Glide Team</span><a href=`#` class='btn btn-primary d-none'>Close</a></div>";
      }
    };
    // Send the request
    const postData =
      `action=patient_feedback_submit&nonce=${encodeURIComponent(
        glide_custom_data.ajax_nonce
      )}&` + formDataString;
    request.send(postData);
  }
})();
